export const getProfileDirectSrc = (profile) => {
	const profileImage = profile?.profile_image;

	if (profileImage && typeof profileImage === 'object') {
		return profileImage.base64 || profileImage.url || null;
	}

	return profile?.image || null;
};
